import React from "react";
import Section from "../components/Section";

function Tutorials() {
  return (
    <div className="page-container">
      {/* Header Image */}
      <img
        src="./tutorials/Tutorials_header.png"
        alt="Tutorials"
        className="header-img"
      />

      {/* Online Tutorials */}
      <h1 className="section-header">Online Tutorials</h1>

      <Section 
        header={
          <h2 className="sub-header">
            <a href="https://drive.google.com/drive/u/0/folders/1s3TwO1C1jdSgY384pxyqugdI7OMwtjJq" target="_blank" rel="noopener noreferrer">
              T02
            </a> - Academic Paper Reviewing (W02)
          </h2>
        }
        content={
          <div className="section-text">
            <div className="video-wrapper">
              <iframe
                src="https://vimeo.com/showcase/10119084/embed"
                title="T02 - Academic Paper Reviewing"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        }
      />

      {/* In-person Tutorials */}
      <h1 className="section-header">In-person Tutorials</h1>
      <Section 
        header={
          <h2 className="sub-header">
            <a href="https://drive.google.com/drive/u/0/folders/1SZvSjM4t2ecC1fN_88JjAqmpkiFs-cOz" target="_blank" rel="noopener noreferrer">
              T01
            </a> - Interaction Design (W02)
          </h2>
        } 
      />
      <Section
        header={
          <h2 className="sub-header">
            <a href="https://drive.google.com/drive/u/0/folders/1-zKzGGSjgXoMbcemoFI20tO-jKXko2C7" target="_blank" rel="noopener noreferrer">
              T03A
            </a> - Programming Basics (W03)
          </h2>
        } 
      />
      <Section 
        header={
          <h2 className="sub-header">
            <a href="https://drive.google.com/drive/u/0/folders/1FzR3y9_geiMZX2FzrnaIwP49dsqUGVJr" target="_blank" rel="noopener noreferrer">
              T03B
            </a> - Advanced Programming (W03)
          </h2>
        } 
      />
      <Section 
        header={
          <h2 className="sub-header">
            <a href="https://drive.google.com/drive/u/0/folders/10cd4GKOw73nh0kO5bD9n5o1XUrnxuqUw" target="_blank" rel="noopener noreferrer">
              T04
            </a> - Electronics Workshop (W05)
          </h2>
        } 
      />
      <Section 
        header={
          <h2 className="sub-header">
            <a href="https://drive.google.com/drive/u/0/folders/1DnVtkhST4vPaKkv3Ymj2-EDHsQoa7BRy" target="_blank" rel="noopener noreferrer">
              T05
            </a> - CAD/3D Design Workshop (W07)
          </h2>
        } 
      />
      <Section 
        header={
          <h2 className="sub-header">
            <a href="https://drive.google.com/drive/u/0/folders/1QPYHWyLbXUIHCMjcG1AJDNeRPLS1tlJF" target="_blank" rel="noopener noreferrer">
              T06
            </a> - Physical Fabrication (W09)
          </h2>
        } 
      />
      <Section 
        header={
          <h2 className="sub-header">
            <a href="https://drive.google.com/drive/u/0/folders/1f6kCTFA6BUoVzZxqYdafF4oAarSjpkn3" target="_blank" rel="noopener noreferrer">
              T07
            </a> - Demo Video Production (W10)
          </h2>
        } 
      />
      <Section 
        header={
          <h2 className="sub-header">
            <a href="https://drive.google.com/drive/u/0/folders/1VlxMbcCNcrL3TgGTW8w1DEA3ynLuHps2" target="_blank" rel="noopener noreferrer">
              T08
            </a> - Academic Paper Writing (W11)
          </h2>
        } 
      />

      {/* Extra Tutorials */}
      <h1 className="section-header">Extra Tutorials</h1>

      <Section
        header={<h2 className="sub-header">Introduction to Unreal</h2>}
        content={
          <div className="section-text">
            <div className="video-wrapper">
              <iframe
                src="https://vimeo.com/showcase/9213768/embed"
                title="Extra Tutorials 1"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        }
      />  
      <Section 
        header={<h2 className="sub-header">Unreal Programming</h2>}
        content={
          <div className="section-text">
            <div className="video-wrapper">
              <iframe
                src="https://vimeo.com/showcase/9234668/embed"
                title="Extra Tutorials 2"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        }
      />
    </div>
  );
}

export default Tutorials;
